import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Início', href: '#inicio' },
  { label: 'Escritório', href: '#escritorio' },
  { label: 'Áreas', href: '#areas' },
  { label: 'Estratégia', href: '#como-atuamos' },
  { label: 'Contato', href: '#contato' },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-white shadow-sm py-3">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="#inicio" className="flex items-center cursor-pointer">
          <img
            src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/1df16a0421aff30730be1a43f64118c6.png"
            alt="Hélio de Oliveira & Santos Oliveira Advogados"
            className="h-[72px] w-auto object-contain"
          />
        </a>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-9">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-[#1B2A4A] text-sm font-medium tracking-widest uppercase hover:text-[#C8A96A] transition-colors duration-300 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden lg:block">
          <a
            href="#contato"
            className="px-7 py-2.5 bg-[#C8A96A] text-white text-xs font-semibold tracking-widest uppercase hover:bg-[#b8954f] transition-all duration-300 cursor-pointer whitespace-nowrap rounded-md"
          >
            Falar com advogado
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          className="lg:hidden text-[#1B2A4A] cursor-pointer w-8 h-8 flex items-center justify-center"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-[#C8A96A]/20 px-6 pb-8 pt-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="block py-4 text-[#1B2A4A] text-sm font-medium tracking-widest uppercase border-b border-[#1B2A4A]/10 cursor-pointer hover:text-[#C8A96A] transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contato"
            className="block mt-6 px-7 py-3 bg-[#C8A96A] text-white text-xs font-semibold tracking-widest uppercase text-center cursor-pointer hover:bg-[#b8954f] transition-all duration-300 rounded-md"
            onClick={() => setMenuOpen(false)}
          >
            Falar com advogado
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
